/* --------------------------------------------------------------------------------------
   xwCarousel.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwCarousel {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
      autoplay: '<',
      infinite: '<',
      centerMode: '<'
    }
  }
  link(scope, elem, attrs) {

    let options = {
      autoplay: scope.autoplay,
      infinite: scope.infinite,
      centerMode: scope.centerMode
    }
    setTimeout(() => elem.first().xrxcarousel(options))
  }
  static directiveFactory() {
    xwCarousel.instance = new xwCarousel()
    return xwCarousel.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwCarousel.directive.js